import type { Logger } from '@vp/ubik-logging'

import type { WorkData } from '../types/Work'
import type { WorkId } from '../types/WorkId'
import type { IQuotePrice } from '../types/Price'
import { buildWebsitePricingQuoteRequest } from '../utils/WebsitePricingHelpers'
import { REQUESTOR } from '../utils/constants'

const baseUrl = 'https://website-pricing-service-cdn.prices.cimpress.io/v4/prices'

export const getPriceQuote = async (
  worksData: Record<WorkId, WorkData>,
  market: string,
  merchantId: string,
  authorizationHeader: string,
  couponCode: string | undefined,
  customerGroups: string[],
  logger: Logger,
): Promise<IQuotePrice> => {
  const body = buildWebsitePricingQuoteRequest(worksData, market, merchantId, couponCode, customerGroups)

  if (Object.keys(body).length === 0) {
    return {} as IQuotePrice
  }

  const queryParams = new URLSearchParams({
    requestor: REQUESTOR,
  })

  const url = `${baseUrl}/quote?${queryParams.toString()}`

  try {
    const headers = { Authorization: authorizationHeader, 'Content-Type': 'application/json' }
    const request = new Request(url, {
      method: 'POST',
      headers,
      body: JSON.stringify(body),
    })

    const response = await fetch(request)
    if (!response.ok) {
      throw new Error(`Request to ${url} failed with status: ${response.status}`)
    }

    const data = (await response.json()) as IQuotePrice
    return data
  } catch (error) {
    logger.error('Unable to retrieve pricing quote', error as Error, { workIds: Object.keys(worksData), market, url, body })
    return {} as IQuotePrice
  }
}
